import React from "react";
import PreviousSSD from "../../sanityInterfaces/PreviousSSD";

interface contentProps {
  data: PreviousSSD;
}

const TechnicalProgContent = (props: contentProps) => {
  const TABLE_HEAD_1 = [
    "Communication, Signal Processing & Information Technology (CSP)",
    "Power Systems & Smart Energies (PSE)",
  ];
  const TABLE_HEAD_2 = [
    "Systems, Automation & Control (SAC)",
    "Sensors, Circuits and Instrumentation Systems (SCI)",
  ];

  // ✅ Reusable link button style (same as FileButton)
  const linkButtonStyle =
    "transition text-sm sm:text-md font-semibold text-blue-902 rounded-md border shadow-md px-3 py-2 sm:px-4 sm:py-3 hover:bg-blue-901 hover:text-white block text-center truncate";

  return (
    <div className="p-4">
      <div className="text-left mx-2 sm:mx-10 grid gap-3">
        <h1 className="text-2xl font-semibold text-red-400">Plenaries</h1>

        {/* ✅ Responsive grid for link buttons */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
          {[
            { label: "Opening PL 1 File", ref: props?.data?.OpeningPL1?.asset?._ref },
            { label: "PL 2 KL SAC1 File", ref: props?.data?.PL2KLSAC1?.asset?._ref },
            { label: "PL 3 File", ref: props?.data?.PL3?.asset?._ref },
            { label: "PL 4 File", ref: props?.data?.PL4?.asset?._ref },
            { label: "PL5KLSAC2 File", ref: props?.data?.PL5KLSAC2?.asset?._ref },
            { label: "PhD3M File", ref: props?.data?.PhD3M?.asset?._ref },
          ].map((item, index) => (
            <a
              key={index}
              href={
                item.ref
                  ? `https://cdn.sanity.io/files/79vgbaej/production/${item.ref.slice(
                      5,
                      -4
                    )}.${item.ref.slice(-3)}`
                  : "#"
              }
              className={linkButtonStyle}
            >
              {item.label}
            </a>
          ))}
        </div>

        {/* ✅ Tables formatted for all devices */}
        <table className="w-full table-auto text-left border-collapse mt-6">
          <thead>
            <tr>
              {TABLE_HEAD_1.map((head) => (
                <th
                  key={head}
                  className="border-b border-blue-gray-100 bg-blue-gray-50 p-2 sm:p-4 text-xs sm:text-sm font-semibold text-gray-700 w-1/2"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props?.data?.CommunicationSignalProcessingInformationTechnology?.map(
              (item, index) => {
                const classes =
                  "p-2 sm:p-4 border-b border-blue-gray-50 text-xs sm:text-sm whitespace-normal break-words align-top";
                return (
                  <tr key={index}>
                    <td
                      className={`${classes} blue_td hover:bg-blue-500 hover:text-white`}
                    >
                      {item.file && (
                        <a
                          className="text-blue-500 hover:text-white"
                          href={`https://cdn.sanity.io/files/79vgbaej/production/${item.file.asset._ref.slice(
                            5,
                            -4
                          )}.${item.file.asset._ref.slice(-3)}`}
                        >
                          {item.Title}
                        </a>
                      )}
                    </td>
                    <td
                      className={`${classes} bg-blue-gray-50/50 blue_td hover:bg-blue-500 hover:text-white`}
                    >
                      {props?.data?.PowerSystemsSmartEnergies?.[index]?.file && (
                        <a
                          className="text-blue-500 hover:text-white"
                          href={`https://cdn.sanity.io/files/79vgbaej/production/${props?.data.PowerSystemsSmartEnergies[
                            index
                          ].file.asset._ref.slice(5, -4)}.${
                            props?.data.PowerSystemsSmartEnergies[index].file.asset._ref.slice(
                              -3
                            )
                          }`}
                        >
                          {
                            props?.data.PowerSystemsSmartEnergies[index]
                              .Title
                          }
                        </a>
                      )}
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>

        <table className="w-full table-auto text-left border-collapse mt-6">
          <thead>
            <tr>
              {TABLE_HEAD_2.map((head) => (
                <th
                  key={head}
                  className="border-b border-blue-gray-100 bg-blue-gray-50 p-2 sm:p-4 text-xs sm:text-sm font-semibold text-gray-700 w-1/2"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props?.data?.SystemsAutomationControl?.map((item, index) => {
              const classes =
                "p-2 sm:p-4 border-b border-blue-gray-50 text-xs sm:text-sm whitespace-normal break-words align-top";
              return (
                <tr key={index}>
                  <td
                    className={`${classes} blue_td hover:bg-blue-500 hover:text-white`}
                  >
                    {item.file && (
                      <a
                        className="text-blue-500 hover:text-white"
                        href={`https://cdn.sanity.io/files/79vgbaej/production/${item.file.asset._ref.slice(
                          5,
                          -4
                        )}.${item.file.asset._ref.slice(-3)}`}
                      >
                        {item.Title}
                      </a>
                    )}
                  </td>
                  <td
                    className={`${classes} bg-blue-gray-50/50 blue_td hover:bg-blue-500 hover:text-white`}
                  >
                    {props?.data.SensorsCircuitsandInstrumentationSystems?.[
                      index
                    ]?.file && (
                      <a
                        className="text-blue-500 hover:text-white"
                        href={`https://cdn.sanity.io/files/79vgbaej/production/${props?.data.SensorsCircuitsandInstrumentationSystems[
                          index
                        ].file.asset._ref.slice(5, -4)}.${
                          props?.data.SensorsCircuitsandInstrumentationSystems[
                            index
                          ].file.asset._ref.slice(-3)
                        }`}
                      >
                        {
                          props?.data.SensorsCircuitsandInstrumentationSystems[
                            index
                          ].Title
                        }
                      </a>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* ✅ Bottom resource buttons (same styling) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 mt-4">
          {[
            { label: "SSD-Abstract Book", ref: props?.data?.SSDAbstractBook?.asset?._ref },
            { label: "SSD-Program Book", ref: props?.data?.SSDProgramBook?.asset?._ref },
            { label: "SSD-Social Program", ref: props?.data?.SSDSocialProgram?.asset?._ref },
            { label: "WS-1–SSD meeting", ref: props?.data?.WS1SSDmeeting?.asset?._ref },
            { label: "WS-2–closure", ref: props?.data?.WS2closure?.asset?._ref },
          ].map((item, index) => (
            <a
              key={index}
              href={
                item.ref
                  ? `https://cdn.sanity.io/files/79vgbaej/production/${item.ref.slice(
                      5,
                      -4
                    )}.${item.ref.slice(-3)}`
                  : "#"
              }
              className={linkButtonStyle}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechnicalProgContent;
